import { TFunction } from 'i18next'

import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

import { Td } from './styled-components'

interface SearchResultRowProps {
  fullName: string
  email: string
  isTester: boolean
  onAdd: () => void
  t: TFunction
}

const SearchResultRow = ({ fullName, email, isTester, onAdd, t }: SearchResultRowProps) => (
  <tr>
    <Td>{fullName}</Td>
    <Td>{email}</Td>
    <Td>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton block={false} disabled={isTester} onClick={onAdd}>
        {t(isTester ? 'beta_features.already_tester' : 'beta_features.add')}
      </SDButton>
    </Td>
  </tr>
)

export default SearchResultRow
